import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { Observable } from 'rxjs';

/**
 * Version tag for the translation files, unique per build.
 *
 * `es.json` keeps the same URL across deploys, so browsers reuse a stale copy for days and new
 * keys render as raw ids. Deployed builds have content-hashed bundles (`main-XXXXXXXX.js`); that
 * hash changes on every deploy, so it is used as a cache-busting query param. Local dev (no hash)
 * falls back to a per-session value.
 */
function translationsVersion(): string {
	if (typeof document === 'undefined') return '';
	const main = document.querySelector<HTMLScriptElement>('script[src*="main-"]');
	const hash = main?.getAttribute('src')?.match(/main-([A-Za-z0-9]+)\.js/)?.[1];
	return hash ?? String(Date.now());
}

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
	private http = inject(HttpClient);
	private readonly version = translationsVersion();

	getTranslation(lang: string): Observable<Translation> {
		const query = this.version ? `?v=${this.version}` : '';
		return this.http.get<Translation>(`/assets/i18n/${lang}.json${query}`);
	}
}
